import React, { Fragment } from "react";
import Footer from "./Footer";
import HeroPhoto from "./HeroPhoto";

const ConocimientosBD = () => {
  const contactos = [
    { label: "Email", value: "koeman1976sf@gmail.com", href: "mailto:koeman1976sf@gmail.com" },
    { label: "Web", value: "joseanavas.com", href: "https://www.joseanavas.com" },
    {
      label: "LinkedIn",
      value: "Perfil",
      href: "https://www.linkedin.com/in/jose-antonio-navas-ruiz-25694859/",
    },
    { label: "X / Twitter", value: "@koeman1976", href: "https://twitter.com/koeman1976?s=09" },
  ];

  const skills = [
    {
      title: "SQL Server",
      level: "Alta",
      tags: ["T-SQL", "Modelado", "Performance", "SPs", "DBA"],
      bullets: [
        "Experiencia desde 2005 con SQL Server.",
        "Diseño avanzado de BBDD a partir de diagramas UML / ER.",
        "Programación en BD: procedimientos, triggers, índices, optimización.",
        "Transact-SQL (T-SQL) avanzado.",
        "Gestión y administración de bases de datos (perfil DBA funcional).",
      ],
    },
    {
      title: "Cloud / Data",
      level: "Media",
      tags: ["Azure", "Firebase", "Firestore", "MongoDB", "Headless CMS"],
      bullets: ["Microsoft Azure.", "Firebase y Firestore.", "MongoDB.", "DataCMS (Headless CMS)."],
    },
    {
      title: "Otras bases de datos",
      level: "Mixta",
      tags: ["SQLite", "Oracle", "MySQL"],
      bullets: [
        "SQLite para movilidad.",
        "Oracle (nivel medio).",
        "MySQL (nivel medio).",
      ],
    },
  ];

  return (
    <Fragment>
      <main className="cvMain">
        {/* HERO */}
        <section className="cvHero cvHero2026">
          <div className="cvContainer cvHeroGrid">
            <div className="cvHeroLeft">
              <p className="cvKicker">Conocimientos</p>
              <h1 className="cvTitle">Bases de datos</h1>
              <p className="cvSubtitle">Responsable IT / .NET Senior · SQL Server · Integración · Operación</p>

              <div className="cvMeta">
                <span className="cvMetaItem">Madrid</span>
                <span className="cvMetaDot" aria-hidden="true" />
                <span className="cvMetaItem">Rendimiento · Fiabilidad · Modelado</span>
              </div>
            </div>

            <aside className="cvHeroRight" aria-label="Fotografía">
              <HeroPhoto />
            </aside>
          </div>
        </section>

        {/* CONTENIDO 2 COLUMNAS */}
        <section className="cvSection">
          <div className="cvContainer cvTwoCol">
            {/* Lateral */}
            <aside className="cvSide">
              <div className="cvCard">
                <h2 className="cvH2">Resumen</h2>
                <p className="cvP">
                  Foco principal en SQL Server: modelado, T-SQL, optimización y soporte a entornos críticos.
                  Experiencia complementaria en Azure y otras BBDD según necesidad del proyecto.
                </p>
              </div>

              <div className="cvCard">
                <h2 className="cvH2">Contacto</h2>
                <ul className="cvList">
                  {contactos.map((c) => (
                    <li key={c.label} className="cvListItem">
                      <span className="cvMuted">{c.label}:</span>{" "}
                      <a className="cvLink" href={c.href} target="_blank" rel="noreferrer">
                        {c.value}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="cvCard">
                <h2 className="cvH2">Idiomas</h2>
                <ul className="cvList">
                  <li className="cvListItem">
                    Español <span className="cvMuted">(Nativo)</span>
                  </li>
                  <li className="cvListItem">
                    Inglés <span className="cvMuted">(Medio/Alto)</span>
                  </li>
                </ul>
              </div>
            </aside>

            {/* Principal */}
            <div className="cvContent">
              <div className="cvSectionHead">
                <h2 className="cvH2">Conocimientos BD</h2>
                <p className="cvMuted">Competencias y nivel de experiencia.</p>
              </div>

              <div className="cvTimeline">
                {skills.map((s) => (
                  <article key={s.title} className="cvCard cvItem">
                    <div className="cvItemHead">
                      <div>
                        <h3 className="cvH3">{s.title}</h3>
                        <p className="cvMuted">Experiencia: {s.level}</p>
                      </div>

                      <div className="cvTags">
                        {s.tags.map((t) => (
                          <span key={t} className="cvTag">
                            {t}
                          </span>
                        ))}
                      </div>
                    </div>

                    <ul className="cvBullets">
                      {s.bullets.map((b, idx) => (
                        <li key={idx}>{b}</li>
                      ))}
                    </ul>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </Fragment>
  );
};

export default ConocimientosBD;
